import { render, staticRenderFns } from "./addFaxBoxDialog.vue?vue&type=template&id=489ed57c&"
import script from "./addFaxBoxDialog.vue?vue&type=script&lang=js&"
export * from "./addFaxBoxDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports